<template>
    <div class="lunboView">
        <div class="visible-md-block visible-lg-block da">
            <div class="swiper-container">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(item ,index) in daImage" :key="index">
                        <img :src="item" alt="">
                    </div>
                </div>
                <div class="swiper-pagination"></div>
            </div>

        </div>
        <div class="visible-sm-block visible-xs-block xiao" style="position: relative">
            <div style="width: 100%;overflow: hidden;">
                <div class="swiper-container2">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item ,index) in daImage" :key="index">
                            <div class="mimageBox imageBox imageBox1">
                                <img :src="item" alt="" width="100%">
                            </div>
                        </div>

                    </div>
                    <!-- Add Pagination -->
                    <div class="swiper-pagination swiper-pagination2"></div>
                    <!-- Add Arrows -->
                    <!--<div class="swiper-button-next"></div>-->
                    <!--<div class="swiper-button-prev"></div>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import Swiper from "swiper";
    export default {
        name: "lunboView",
        data() {
            return {}
        },
        props: {
            daImage: Array,
            slidesPerView: Number
        },
        mounted() {

            var swiper = new Swiper('.swiper-container', {
                pagination: '.swiper-pagination',
                slidesPerView: this.slidesPerView?this.slidesPerView:3,
                paginationClickable: true,
                spaceBetween: 30
            });
            var swiper2 = new Swiper('.swiper-container2', {
                pagination: '.swiper-pagination2',
                paginationClickable: true
            });
        }
    }
</script>

<style>
    .lunboView .da .swiper-container {
        width: 100%;
        height: 100%;
        padding-bottom: 50px;
    }
    .lunboView .xiao .swiper-container2 {
        padding-bottom: 50px;
    }
    .lunboView .da .swiper-slide {
        text-align: center;
        font-size: 18px;
        background: #fff;

        /* Center slide text vertically */
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
    }


    .lunboView .xiao .swiper-container {
        width: 100%;
        height: 100%;

    }
    .lunboView .xiao .swiper-slide {
        text-align: center;
        font-size: 18px;
        background: #fff;

        /* Center slide text vertically */
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
    }
    .lunboView .xiao .swiper-slide .imageBox{
        width: 100%;
        height: 100%;
        background-repeat: no-repeat;
        background-size: 100% auto;
        background-position: center;
    }

    .lunboView .xiao  .swiper-slide .imageBox.mimageBox{
        width: 60%;
        /*height: 600px;*/
        /*background-size: 100% 100%;*/
        text-align: center;
    }

    /*.lunboView .xiao .swiper-slide .imageBox.mimageBox.imageBox1{*/
        /*background-image: url("../../../static/img/invasion/INVASION-PC端-1.png");*/
    /*}*/
    /*.lunboView .xiao .swiper-slide .imageBox.mimageBox.imageBox2{*/
        /*background-image: url("../../../static/img/invasion/INVASION-PC端-2.png");*/
    /*}*/
    /*.lunboView .xiao .swiper-slide .imageBox.mimageBox.imageBox3{*/
        /*background-image: url("../../../static/img/invasion/INVASION-PC端-3.png");*/
    /*}*/
    /*.lunboView .xiao .swiper-slide .imageBox.mimageBox.imageBox4{*/
        /*background-image: url("../../../static/img/invasion/INVASION-PC端-4.png");*/
    /*}*/
    /*.lunboView .xiao .swiper-slide .imageBox.mimageBox.imageBox5{*/
        /*background-image: url("../../../static/img/invasion/INVASION-PC端-5.png");*/
    /*}*/
    /*.lunboView .xiao .swiper-slide .imageBox.mimageBox.imageBox6{*/
        /*background-image: url("../../../static/img/invasion/INVASION-PC端-6.png");*/
    /*}*/
    /*.lunboView .xiao .swiper-slide .imageBox.mimageBox.imageBox7{*/
        /*background-image: url("../../../static/img/invasion/INVASION-PC端-7.png");*/
    /*}*/
    /*.lunboView .xiao .swiper-slide .imageBox.mimageBox.imageBox9{*/
        /*background-image: url("../../../static/img/invasion/INVASION-PC端-9.png");*/
    /*}*/

    @media (max-width: 768px) {
        .lunboView .xiao .swiper-slide .imageBox.mimageBox {
            width: 80%;
            /*height: 600px;*/
            /*background-size: 100% 100%;*/
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/views/lunboView.vue